import React from "react";

import { useModalAdapter } from "hooks";

import { ModalAdapterProps, ModalTypes } from "constants/navigation";
import { Modal } from "components/CreateSellViaExternalAgentSaleFromSaleModal/Modal";

interface ParamsReturns {
  saleId: number;
}

export const CreateSellViaExternalAgentSaleFromSaleAdapter = (
  props: ModalAdapterProps,
) => {
  const [hashParams, ignored, onClose] = useModalAdapter<ParamsReturns>(
    ModalTypes.CreateSellViaExternalAgentSaleFromSale,
    props,
  );

  const { saleId } = hashParams;

  return <Modal onClose={onClose} saleId={saleId} />;
};
